module.exports = __webpack_public_path__ + "img/pig.8ae728c6.png";